import React from 'react'

const About = () => {
    return (
        <div className="text-center">
            <h1>About This App</h1>
            <p>App to search Github User</p>
            <small>Version 1.0.0</small>
            <p>For More details Email us to</p>
            <p >sherazararin05@gmail.com</p>

        </div>
    )
}

export default About;